enum eFormType {
    New ,
    Edit
}

export default eFormType